/**
 * Interface representing the order information generated by the Unity WebGL app.
 */

interface IOrder {
    Name: string;
    LongName: string;
    ID: string;
    ProductID: string;
    Duplung?: {
        ProductID: string;
        PatternOriented: boolean;
        Fixing: "Gluing" | "Screwing";
    };
    BlockCutting?: {
        Name: string;
        BoardIndex: number;
        BoardCount: number;
    };
    Warning?: string;
    Width: number;
    Height: number;
    PatternOriented: boolean;
    Machinings: [];
    Edges: [ {
        Left: {
            ProductID: string;
        }
        Right: {
            ProductID: string;
        }
        Top: {
            ProductID: string;
        }
        Bottom: {
            ProductID: string;
        }
    } ];
}

export default IOrder;
